import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 12px;
  padding: 16px 20px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: 12px;

  .subtitle {
    font-size: 0.85rem;
    color: #6b7280;
    margin-bottom: 0.5rem;
  }

  .menu-top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      text-transform: capitalize;
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 1rem;
      font-weight: bold;
      color: #333;
    }

    button {
      border: none;
      background-color: #4f46e5;
      transition: background 0.3s ease;
      color: white;
      padding: 6px 14px;
      border-radius: 6px;
      font-weight: bold;
      font-size: 0.85rem;
      cursor: pointer;

      :hover {
        background-color: #4338ca;
      }
    }
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #f9fafb;
      padding: 10px 12px;
      border-radius: 8px;
      transition: all 0.2s ease;

      &:hover {
        background: #eef2ff;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(79, 70, 229, 0.08);
      }

      .info {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      .description {
        font-size: 0.85rem;
        font-weight: 600;
        text-transform: capitalize;
        color: #374151;
      }

      .due-date {
        font-size: 0.75rem;
        color: #6b7280;
      }

      .amount {
        font-size: 0.95rem;
        font-weight: bold;
      }

      .amount-red {
        color: #dc2626;
      }

      .amount-green {
        color: #16a34a;
      }
    }

    .not-data {
      color: #6b7280;
      font-weight: 500;
      font-size: 0.85rem;
      text-align: center;
      padding: 1rem 0;
    }
  }
`;
